import Vue from 'vue';

import {
  BForm,
  BFormGroup,
  BFormCheckbox,
  BFormInput,
  BAlert,
  BCollapse,
  BModal,
  BTabs,
  BTab,
  BFormTextarea,
  BFormSelect,
  BCard,
  BCardText,
  VBModal,
  VBToggle
} from 'bootstrap-vue';

Vue.component('BForm', BForm);
Vue.component('BFormGroup', BFormGroup);
Vue.component('BFormCheckbox', BFormCheckbox);
Vue.component('BFormInput', BFormInput);
Vue.component('BAlert', BAlert);
Vue.component('BCollapse', BCollapse);
Vue.component('BModal', BModal);
Vue.component('BTabs', BTabs);
Vue.component('BTab', BTab);
Vue.component('BFormTextarea', BFormTextarea);
Vue.component('BFormSelect', BFormSelect);
Vue.component('BCard', BCard);
Vue.component('BCardText', BCardText);

Vue.directive('BModal', VBModal);
Vue.directive('BToggle', VBToggle);
